import hasExtendedAllowedCharacters from "../validations/has.extended.allowed.characters";

export default (values, value) => hasExtendedAllowedCharacters(value);
